import React from 'react';
import Notification from '../messagerie_user/notification';

function AffichageInfoCoach(props) {
  const apiUrl = process.env.REACT_APP_API_URL;


  return (
    <>
      {props.userData && (
        <>
          {props.equipe && props.equipe.coach && (
            <div className="main equipes_info">
              <Notification userData={props.userData} />
              <div className="joueur">
                <div className="image7">
                  <img
                    src={`${apiUrl}/image/equipe/${props.equipe.coach[0].logo}`}
                    alt=""
                    width="100"
                    height="100"
                  />
                </div>
                <div className="nbr">T1</div>
                <div className="nom">
                  <a href={`/${props.type}/equipe/${props.equipe.coach[0].id_equipe}`}>
                    Entraineur du {props.equipe.coach[0].nom_equipe} ({props.equipe.coach[0].categorie})
                  </a>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <table>
                    <tbody>
                      <tr>
                        <td>Nom</td>
                        <td>:</td>
                        <td>{props.equipe.coach[0].nom}</td>
                      </tr>
                      <tr>
                        <td>Prenom</td>
                        <td>:</td>
                        <td>{props.equipe.coach[0].prenom}</td>
                      </tr>
                      <tr>
                        <td>Date de naissance</td>
                        <td>:</td>
                        <td>{props.equipe.coach[0].naissance}</td>
                      </tr>
                      <tr>
                        <td>Numéro de téléphone</td>
                        <td>:</td>
                        <td>{props.equipe.coach[0].contact}</td>
                      </tr>
                      <tr>
                        <td>Adresse du club</td>
                        <td>:</td>
                        <td>{props.equipe.coach[0].adresse}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default AffichageInfoCoach;
